import { HStack, Select } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";

const GroupByPotential = observer(() => {
  const { pageStore } = useStores();
  return (
    <HStack>
      <Select
        placeholder="Полностью"
        value={pageStore.group_by_potential}
        onChange={(e) => pageStore.updateGroupByPotential(e.target.value)}
        bgColor={"rgb(51, 51, 51)"}
        style={{
          width: "300px",
          border: "none",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
          background: "rgb(51, 51, 51)",
        }}
      >
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="manager-deals">Менеджер — Сделки</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="manager-partner">Менеджер — Контрагенты</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="partner-manager">Контрагенты — Менеджер</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="producer-manager">Производитель — Менеджер</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="manager-producer">Менеджер — Производитель</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="producer-producer">Производитель</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="partner-partner">Контрагенты</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="departament-manager">ОП с РОПом</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="departament-manager-withoutROP">ОП без РОПа</option>
        <option style={{ background: "rgb(51, 51, 51)", color: "#EEEEEE" }} value="partner-deals">Контрагенты — Сделки</option>
      </Select>
    </HStack>
  );
});

export default GroupByPotential;
